import { createContext, useContext } from 'react';
import { IBillingItem } from './useBilling';

interface BillingContextType {
  listIds: string[];
  listData: Record<string, IBillingItem>;
}

export const BillingContext = createContext<BillingContextType | undefined>(undefined);

export const useBillingContext = () => {
  const context = useContext(BillingContext);
  if (!context) {
    throw new Error('useBillingContext must be used within a BillingContext.Provider');
  }
  return context;
};
